import type { WrittenPage } from '../../sections'
import { LINKS } from '../links'

/**
 * Neslihan Gündüz Vatansever — kişisel iletişim sayfası.
 *
 * 15.09.2026'da istendi. İngilizcesiyle aynı bölümler, aynı bilgiler; yalnızca
 * söyleyiş Türkçe. Unvan, fotoğraf ve özgeçmiş verilmediği için burada da yok —
 * İngilizce sayfadaki `check` notu bu eksikleri soruyor ve iki dilde
 * tekrarlanmıyor.
 *
 * 15.09.2026'da ekip iletişim sayfalarının birbiriyle bütünlüklü olması istendi:
 * ortalanmış isim, kart başlığının doğrudan adres ya da numara olduğu bir
 * `features` grid'i ve sonda diğer kartlarla aynı iletişim bandı — sondaki
 * paragraf aynı şeyi söylediği için yerini o banda bıraktı.
 *
 * 24.09.2026: sayfanın adresi `about/team/neslihan-gunduz` oldu; adres
 * İngilizce dosyadaki `route` içinde tanımlı, burada değişen bir şey yok.
 */
const EMAIL = 'neslihan@digitopia.ai'
const PHONE_DISPLAY = '+90 536 724 81 75'
const PHONE_DIAL = 'tel:+905367248175'

export const teamNeslihanGunduzVatansever: WrittenPage = {
  navLabel: 'Neslihan Gündüz',
  title: 'Neslihan Gündüz',
  description:
    'Digitopia’dan Neslihan Gündüz ile iletişim: neslihan@digitopia.ai, +90 536 724 81 75.',
  sections: [
    {
      kind: 'hero',
      eyebrow: 'Digitopia',
      headline: 'Neslihan Gündüz',
      align: 'center',
      ctas: [
        { label: 'E-posta', href: `mailto:${EMAIL}` },
        { label: 'Ara', href: PHONE_DIAL },
        // 17.09.2026: telefona doğrudan kaydetmek için vCard. Dosya
        // `public/vcf/` içinde, sayfanın slug'ıyla aynı adda.
        {
          label: 'Rehbere kaydet',
          href: '/vcf/neslihan-gunduz-vatansever.vcf',
        },
      ],
    },
    {
      kind: 'features',
      heading: 'İletişim',
      columns: 2,
      items: [
        {
          title: EMAIL,
          note: 'E-posta',
          href: `mailto:${EMAIL}`,
        },
        {
          title: PHONE_DISPLAY,
          note: 'Türkiye',
          href: PHONE_DIAL,
        },
      ],
    },
    {
      kind: 'cta',
      heading: 'Kişi yerine firmayla mı başlamak istersiniz?',
      sub: 'Hakkımızda, birlikte çalışacağınız diğer isimleri anlatır.',
      tone: 'band',
      ctas: [
        { label: 'Digitopia ile iletişime geçin', href: LINKS.contact },
        { label: 'Hakkımızda', href: LINKS.about },
      ],
    },
  ],
}
